/* 🤖 this file was generated by svg-to-ts */
export const iconInformation: {
  name: 'information';
  data: string;
} = {
  name: 'information',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M4,12 L4,6 C4,5.414 3.586,5 3,5 L0,5 L0,7 C0.586,7 1,7.414 1,8 L1,12 L0,12 L0,14 L5,14 L5,12 L4,12 Z M3.875,1.75 C3.875,0.783 3.091,0 2.125,0 C1.159,0 0.375,0.783 0.375,1.75 C0.375,2.717 1.159,3.5 2.125,3.5 C3.091,3.5 3.875,2.717 3.875,1.75" id="path-1"/></svg>`,
};
